export enum ListItemTypes {
  Inactive = 'Inactive',
  Active = 'Active',
  Detail = 'Detail'
}
